<div
  class="back-btn"
  [style.width.px]="size"
  [style.height.px]="size"
  (click)="onClick()"
>
  <i class="fal fa-angle-left"></i>
</div>
